import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18next'

import { jsonToQueryString } from '@/utils'
import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'

import {
  setSnackbarAction,
  setLoadingFullAction,
} from '@/state/ui/global/slices/index.slices'
import { BONUS_PROGRAMS } from './api.routes'
import ActionTypes from '../constants'

import { GetGamesByProviderPayload, BonusEngineState } from '../models'

const restApiService: RestApiService = Container.get(RestApiService)

export const getAllGamesByProviderThunk = createAsyncThunk(
  ActionTypes.GET_ALL_GAMES,
  async (payload: GetGamesByProviderPayload | any, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'GET',
        endpoint: BONUS_PROGRAMS.FIND_GAMES_PROVIDER,
        queries: jsonToQueryString(payload),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getAllGamesByProviderExtraReducer = (
  builder: ActionReducerMapBuilder<BonusEngineState>,
) => {
  builder.addCase(getAllGamesByProviderThunk.pending, (state) => {
    console.info('payload', state)
    state.isLoading = true
  })
  builder.addCase(
    getAllGamesByProviderThunk.fulfilled,
    (state, { payload }) => {
      console.info('payload2', payload, state)
      state.isLoading = false
      state.games = payload
    },
  )
}

export default getAllGamesByProviderExtraReducer
